import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';


export function searchImei(data){
    return request({
        url:Api.search.list+data.imei,
        method:configs.http.request.methodGet,
        data
    })
}